import React, { useState, useEffect } from 'react'
import View from '@modul-connect/shared/components/atoms/view'
import { InfoText } from '@modul-connect/shared/components/atoms/text/text'
import { getFrequencyOptions, InputSection } from './addMaintenanceModal'
import { Dropdown } from '@modul-connect/shared/components/molecules/dropdown/dropdown'
import { DateSelector } from '@modul-connect/shared/components/molecules/daySelector/daySelector'
import Button from '@modul-connect/shared/components/atoms/button/button.v2'
import NoBluetooth from '@modul-connect/shared/img/BluetoothIconCrossedOut.svg'
import { connect } from 'react-redux'
import { InputField } from '@modul-connect/shared/components/atoms/textInput/inputField'
import { DateTime } from 'luxon'
import Vehicle from '@modul-connect/shared/img/vehicle.svg'
import Workshop from '@modul-connect/shared/img/workshop.svg'
import OnSite from '@modul-connect/shared/img/on_site.svg'
import { createAssetForMaintenance, removeImage } from '../../../../../state/actions/vehicles'
import { getCategoriesForDropdown, getHomebaseOptionsForDropdown } from '../../../../../utils/assets'
import { UploadImagesView } from './uploadImagesView'
import { fetchOrganisationToolConfig } from '../../../../../state/actions/customer'
import { useAuth0 } from '@auth0/auth0-react'
import { DropdownCustomValue } from '@modul-connect/shared/components/molecules/dropdownCustomValue/dropdownCustomValue'

export const AddHomebase = 'Add new homebase'
export const VehicleIcon = <img src={Vehicle} />
export const WorkshopIcon = <img src={Workshop} />
export const OnSiteIcon = <img src={OnSite} />

const getHomebaseByName = (homebases, homebaseName) => {
  return homebases?.find(h => h.name === homebaseName || h.physicalVehiclesName === homebaseName)
}


const AddNewAssetWithMaintenance = ({
  openUploadImage,
  setModalForUploadingImage,
  maintenance_plans,
  saving,
  onSave,
  onClose,
  open,
  accessToken,
  createAssetForMaintenance,
  removeImage,
  initCreateNewHomebase,
  homebaseInput,
  imageUploaded,
  organisationNames,
  fetchOrganisationToolConfig,
  organisationToolConfig
}) => {
  const NoBluetoothIcon = <img src={NoBluetooth} />
  const [name, setName] = useState('')
  const [brand, setBrand] = useState('')
  const [serialNumber, setSerialNumber] = useState('')
  const [category, setCategory] = useState('')
  const [homebaseName, setHomebaseName] = useState('')
  const [organisation, setOrganisation] = useState('')
  const [frequency, setFrequency] = useState('')
  const [date, setDate] = useState(DateTime.local())
  //const [openedNewHomebase, setOpenedNewHomebase] = useState(false)
  const [openedAddImage, setOpenedAddImage] = useState(false)
  const [openedAddImageOfSerial, setOpenedAddImageOfSerial] = useState(false)
  const [uplodedAssetsImage, setUplodedAseetsImage] = useState([])
  const [uplodedImageOfSerial, setUplodedImageOfSerial] = useState([])
  const [hasBeenUploadedAssetImage, setHasBeenUploadedAssetImage] = useState(null)
  const [hasBeenUploadedSerialImage, setHasBeenUploadedSerialImage] = useState(null)
  const [organisationsToSelectFrom, setOrganisationsToSelectFrom] = useState([])
  const [backupHomebaseName, setBackupHomebaseName] = useState('')
  const [backupOrganisation, setBackupOrganisation] = useState('')

  const { getAccessTokenSilently } = useAuth0()

  const hasUploadedImages = (
    !saving.uploadImage || (saving.uploadImage === 'uploaded')
  )

  const disabled = (
    name.trim() === '' ||
    brand.trim() === '' ||
    category.trim() === '' ||
    homebaseName.trim() === '' || homebaseName === AddHomebase ||
    !date ||
    !(frequency || frequency === 0) ||
    !hasUploadedImages ||
    !organisation
  )

  const hasNoToolConfig = organisationToolConfig?.categories.length === 0 && organisationToolConfig?.equipmentNames?.length === 0 && organisationToolConfig?.brands?.length === 0

  useEffect(() => {
    if (organisation)
      getAccessTokenSilently()
        .then(token => {
          fetchOrganisationToolConfig(token, organisation)
        })
  }, [organisation])

  const backupSelectedHomebase = () => {
    setBackupHomebaseName(homebaseName)
    setBackupOrganisation(organisation)
  }

  const sendRemoveImage = (image) => {
    if (!image) return
    const selectedImage = maintenance_plans.images.find(img => img.fileData.fileName === image.name)
    removeImage(accessToken, selectedImage?.fileData?.imageId)
  }

  useEffect(() => {
    if (frequency || frequency === 0)
      setDate(DateTime.local().plus({ days: frequency }))
  }, [frequency])

  useEffect(() => {
    if (!openedAddImage && !openedAddImageOfSerial) {
      setName('')
      setBrand('')
      setSerialNumber('')
      setCategory('')
      setHomebaseName('')
      setFrequency('')
      setUplodedAseetsImage([])
      setHasBeenUploadedAssetImage(null)
      setUplodedImageOfSerial([])
      setHasBeenUploadedSerialImage(null)
    }
  }, [open])


  useEffect(() => {
    if (homebaseName === AddHomebase) {
      initCreateNewHomebase()
    }
  }, [homebaseName])

  useEffect(() => {
    if (!homebaseInput) return

    if (!homebaseInput.id) {
      setOrganisation(backupOrganisation)
      setHomebaseName(backupHomebaseName)

      setBackupHomebaseName('')
      setBackupOrganisation('')
    }

    else {
      setOrganisation(homebaseInput?.organisationId)
      setHomebaseName(homebaseInput?.homebaseName)
    }
  }, [homebaseInput])

  useEffect(() => {
    if (organisationsToSelectFrom?.length === 1) setOrganisation(organisationsToSelectFrom[0]?.id)
  }, [organisationsToSelectFrom])

  useEffect(() => {
    if (organisationNames) {

      setOrganisationsToSelectFrom(Object.keys(organisationNames)?.map(orgId => {
        const reversedOrganisationName = [...organisationNames[orgId]]
        reversedOrganisationName.reverse()
        return {
          id: orgId,
          value: orgId,
          name: reversedOrganisationName?.join(' > ')
        }
      }))
    }
  }, [organisationNames])

  useEffect(() => {
    if (openedAddImage) {
      setUplodedAseetsImage(imageUploaded)
      setOpenedAddImage(false)
    }
    if (openedAddImageOfSerial) {
      setUplodedImageOfSerial(imageUploaded)
      setOpenedAddImageOfSerial(false)
    }
  }, [imageUploaded])

  useEffect(() => {
    if (!maintenance_plans.images?.length) {
      setUplodedAseetsImage([])
      setUplodedImageOfSerial([])
      return
    }
    maintenance_plans.images.map(img => {
      if (img.typeOfImage === 'Asset') {
        if (uplodedAssetsImage?.name && img?.fileData?.fileName === uplodedAssetsImage?.name)
          setHasBeenUploadedAssetImage(true)
        else
          setHasBeenUploadedAssetImage(null)
      }
      else if (img.typeOfImage === 'Serial_id') {
        if (uplodedImageOfSerial?.name && img?.fileData?.fileName === uplodedImageOfSerial?.name)
          setHasBeenUploadedSerialImage(true)
        else
          setHasBeenUploadedSerialImage(null)
      }
    })
  }, [maintenance_plans?.images])

  const sendRequestForNewAsset = () => {
    const homeBaseSelected = getHomebaseByName(maintenance_plans?.homebases, homebaseName)
    const assetImages = []
    const serialImages = []
    if (maintenance_plans?.images?.length)
      maintenance_plans.images.map(img => {
        if (img.typeOfImage === 'Asset')
          assetImages.push(img)
        else if (img.typeOfImage === 'Serial_id')
          serialImages.push(img)
      })

    createAssetForMaintenance(
      accessToken,
      (organisation && organisation !== '') ? organisation : homeBaseSelected?.organisationId,
      name?.trim(),
      category?.trim() ?? null,
      homeBaseSelected?.id,
      homebaseName,
      homeBaseSelected?.type,
      brand?.trim(),
      serialNumber.trim(),
      frequency ? frequency : null,
      date.toISO({ includeOffset: false }),
      null,
      null,
      assetImages,
      serialImages
    )
  }

  return (
    <View style={{ maxHeight: '60vh', overflow: 'scroll' }}>
      <View style={{ display: 'flex', flexDirection: 'row', gap: 8, marginBottom: 16 }}>
        <View style={{ alignSelf: 'flex-start' }}>
          {NoBluetoothIcon}
        </View>

        <InfoText>
          Important!<br />
          Use this option for equipment without an asset tracker.<br />
          If your equipment has a tracker, switch to the “Existing equipment” tab instead.
        </InfoText>
      </View>

      <InputSection>
        <UploadImagesView
          sendRemoveImage={sendRemoveImage}
          uplodedAssetsImage={uplodedAssetsImage}
          openUploadImage={openUploadImage}
          setOpenedAddImage={setOpenedAddImage}
          uplodedImageOfSerial={uplodedImageOfSerial}
          hasBeenUploadedSerialImage={hasBeenUploadedSerialImage}
          setUplodedImageOfSerial={setUplodedImageOfSerial}
          setUplodedAseetsImage={setUplodedAseetsImage}
          setOpenedAddImageOfSerial={setOpenedAddImageOfSerial}
          hasBeenUploadedAssetImage={hasBeenUploadedAssetImage}
          setModalForUploadingImage={setModalForUploadingImage}
        />

        {organisationsToSelectFrom?.length > 1 ?
          <Dropdown
            options={organisationsToSelectFrom?.map(org => { return { name: org.name, id: org.id } })}
            placeholder={'Select organisation'}
            value={organisation}
            onChange={setOrganisation}
            isRequired />
          : null
        }

        {organisation && organisationToolConfig && !hasNoToolConfig && (
          <>
            {organisationToolConfig?.customEquipmentNames ? (
              <DropdownCustomValue             
                size={'small'} 
                placeholder={'Name'}
                value={name} 
                onChange={setName} 
                options={organisationToolConfig?.equipmentNames.map(e => {return { key: e, value: e, name: e }})}
                isRequired
              />
            ) : (
              <Dropdown
                value={name} 
                placeholder={'Name'}
                onChange={setName} 
                options={organisationToolConfig?.equipmentNames.map(e => {return { key: e, value: e, name: e }})}
                isRequired
              />
            )}
            {organisationToolConfig?.customBrands ? (
              <DropdownCustomValue             
                size={'small'} 
                placeholder={'Brand'}
                value={brand} 
                onChange={setBrand} 
                options={organisationToolConfig?.brands.map(b => {return { key: b, value: b, name: b }})}
                isRequired
              />
            ) : (
              <Dropdown
                value={brand} 
                placeholder={'Brand'}
                onChange={setBrand} 
                options={organisationToolConfig?.brands.map(b => {return { key: b, value: b, name: b }})}
                isRequired
              />
            )}
            <InputField placeholder={'Serial Number'} label={'Serial Number'} value={serialNumber} onChange={setSerialNumber} />
            <Dropdown options={organisationToolConfig?.categories.map(c => {return { key: c.name, value: c.name, name: c.name }})} placeholder={'Select category'} value={category} onChange={setCategory} isRequired />
            <Dropdown
              options={getHomebaseOptionsForDropdown(maintenance_plans, true, backupSelectedHomebase)}
              disabled={saving?.newHomebase === 'saving'}
              processing={saving?.newHomebase === 'saving'}
              placeholder={'Select homebase'}
              value={homebaseName}
              onChange={setHomebaseName}
              isRequired />
          </>
        )}

        {organisation && hasNoToolConfig && (
          <>
            <InputField placeholder={'Name'} label={'Name'} value={name} onChange={setName} isRequired />
            <InputField placeholder={'Brand'} label={'Brand'} value={brand} onChange={setBrand} isRequired />
            <InputField placeholder={'Serial Number'} label={'Serial Number'} value={serialNumber} onChange={setSerialNumber} />
            <Dropdown options={getCategoriesForDropdown()} placeholder={'Select category'} value={category} onChange={setCategory} isRequired />
            <Dropdown
              options={getHomebaseOptionsForDropdown(maintenance_plans, true, backupSelectedHomebase)}
              disabled={saving?.newHomebase === 'saving'}
              processing={saving?.newHomebase === 'saving'}
              placeholder={'Select homebase'}
              value={homebaseName}
              onChange={setHomebaseName}
              isRequired />
          </>
        )}

        <Dropdown
          title={'Maintenance frequency'}
          options={getFrequencyOptions([])}
          placeholder={'Select frequency'}
          value={frequency}
          onChange={setFrequency}
          isRequired />


        <DateSelector
          title={'Due date'}
          date={date}
          onDayPicked={(newDate) => setDate(newDate)}
          disableDaysBefore={DateTime.local()}
          isRequired
        />

        <View style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end', fontSize: 12 }}>
          * Required fields
        </View>

        <View style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end', gap: 10 }}>
          <Button
            extend={{ width: '30%' }}
            disabled={disabled}
            onClick={() => {
              sendRequestForNewAsset()
              onSave()
            }}
          >
            {'Save'}
          </Button>

          <Button
            noBg
            border
            onClick={() => {
              onClose()
            }}
          >
            {'Cancel'}
          </Button>
        </View>

      </InputSection>
    </View>
  )
}

const mapStateToProps = props => props

const mapDispatchToProps = dispatch => ({
  createAssetForMaintenance: (accessToken, organisationId, assetName, category, homebase, homebaseName, homebaseType, brand, serialNumber, frequency, dueDate, instructions, maintenanceName, assetImages, serialImages) =>
    dispatch(createAssetForMaintenance(accessToken, organisationId, assetName, category, homebase, homebaseName, homebaseType, brand, serialNumber, frequency, dueDate, instructions, maintenanceName, assetImages, serialImages)),
  removeImage: (accessToken, imageId) => dispatch(removeImage(accessToken, imageId)),
  fetchOrganisationToolConfig: (accessToken, orgId) => dispatch(fetchOrganisationToolConfig(accessToken, orgId))
})

export default connect(mapStateToProps, mapDispatchToProps)(AddNewAssetWithMaintenance)
